import { render, staticRenderFns } from "./InstantCreditPayment.vue?vue&type=template&id=2e9d3248"
import script from "./InstantCreditPayment.vue?vue&type=script&setup=true&lang=js"
export * from "./InstantCreditPayment.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports